export default "__VITE_ASSET__Ns1x8qON__"